'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactRouter = require('react-router');

var _SHARE = require('components/SHARE');

var _components2 = require('components');

var _ProcessInput = require('components/Order/ProcessInput');

var _ProcessInput2 = _interopRequireDefault(_ProcessInput);

require('./PaymentOrder.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    PaymentOrderView: {
        displayName: 'PaymentOrderView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/Order/default/PaymentOrderView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var PaymentOrderView = _wrapComponent('PaymentOrderView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(PaymentOrderView, _Component);

    function PaymentOrderView(props) {
        (0, _classCallCheck3.default)(this, PaymentOrderView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PaymentOrderView.__proto__ || (0, _getPrototypeOf2.default)(PaymentOrderView)).call(this, props));

        _this.onPay = function (event) {
            event.preventDefault();
            _this.props.onPay();
        };

        _this.productsTable = function () {
            var currency = _this.props.currency;

            return _this.props.products.map(function (item) {
                var pictures = item.offer.pictures || [];
                var image = pictures[0];
                var quantity = parseInt(item.quantity, 10) || 0;
                var weight = null;
                var childWeight = null;
                var modifier_option_name = _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-3 prod_desc' },
                    _react3.default.createElement('div', { className: 'title' })
                );
                item.additionalInfo = item.additional_info ? JSON.parse(item.additional_info) : null;
                if (item.additionalInfo && item.additionalInfo.custom_fields) {
                    item.custom_fields = item.additionalInfo.custom_fields;
                }

                if (item.modifier_option_name !== null && item.modifier_option_name !== '') {
                    modifier_option_name = _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-3 prod_desc' },
                        _react3.default.createElement(
                            'div',
                            { className: 'title' },
                            item.modifier_option_name
                        )
                    );
                } else if (item.modifier_option_id !== null) {
                    modifier_option_name = _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-3 prod_desc' },
                        _react3.default.createElement(
                            'div',
                            { className: 'title' },
                            item.modifiedOption.name
                        )
                    );
                }
                return _react3.default.createElement(
                    'div',
                    { className: 'row no-margin cart-item' },
                    _react3.default.createElement(
                        'div',
                        { className: 'col-sm-1 col-xs-12' },
                        image && image.preview_url ? _react3.default.createElement('img', { src: image.preview_url }) : null
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-4' },
                        _react3.default.createElement(
                            'div',
                            null,
                            _react3.default.createElement(
                                'div',
                                { className: 'title' },
                                _react3.default.createElement(
                                    _reactRouter.Link,
                                    { to: '/product/' + item.offer.id },
                                    item.offer.name
                                )
                            ),
                            _react3.default.createElement(_SHARE.SwitherDescription, { description: item.offer.description }),
                            item.custom_fields ? item.custom_fields.map(function (product, i) {
                                return _react3.default.createElement(
                                    'label',
                                    null,
                                    product.name,
                                    ': ',
                                    product.value
                                );
                            }) : null
                        )
                    ),
                    modifier_option_name,
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-2 text-center' },
                        _react3.default.createElement(
                            'div',
                            { className: 'quantity cart_quantity' },
                            _react3.default.createElement(
                                'span',
                                { className: 'visible-xs' },
                                _this.props.lang['store.common.quantity'],
                                ': '
                            ),
                            _react3.default.createElement(
                                'span',
                                null,
                                quantity
                            )
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-2 text-center' },
                        _react3.default.createElement(
                            'div',
                            { className: 'price' },
                            _react3.default.createElement(_components2.MoneyValue, {
                                value: parseFloat(item.price * quantity),
                                icon: currency.icon,
                                iconAfterValue: currency.icon_after_value
                            })
                        )
                    ),
                    _react3.default.createElement('div', { className: 'clearfix' }),
                    item.type_id === 5 ? item.childProducts.map(function (childItem) {
                        return _this.renderNested(childItem);
                    }) : null
                );
            });
        };

        _this.renderNested = function (childItem) {
            var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            var weight = childItem.quantity;
            childItem.weight_offer = childItem.weight_offer * 1;
            if ((childItem.unit.slug === 'kg' || childItem.unit.slug === 'mg') && childItem.weight_offer && childItem.weight_offer > 0 && childItem.quantity > 0) {
                weight = childItem.weight_offer * childItem.quantity;
                weight = weight.toFixed(3);
                if (childItem.weight_offer < 0.01 && childItem.quantity < 1 || childItem.weight_offer < 1 && childItem.quantity < 0.01) {
                    weight = item.weight_offer * 1;
                }
                if (childItem.weight_offer < 0.1 && childItem.quantity < 0.1) {
                    weight = childItem.weight_offer * 1;
                }
            }
            var paddingLeft = level * 30 + 'px';
            return _react3.default.createElement(
                'div',
                { className: 'row no-margin' },
                _react3.default.createElement('div', { className: 'col-sm-1  col-xs-12' }),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-4' },
                    _react3.default.createElement(
                        'div',
                        { className: 'title', style: { paddingLeft: paddingLeft } },
                        '- ',
                        childItem.name
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-3' },
                    _react3.default.createElement(
                        'div',
                        { className: 'title' },
                        childItem.modifier_option_name
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-2' },
                    _react3.default.createElement(
                        'div',
                        { style: { textAlign: 'center' } },
                        _react3.default.createElement(
                            'span',
                            { className: 'visible-xs' },
                            _this.props.lang['store.common.quantity'],
                            ': '
                        ),
                        childItem.type_id === 5 ? _react3.default.createElement(
                            'span',
                            null,
                            childItem.quantity
                        ) : _react3.default.createElement(
                            'span',
                            null,
                            weight,
                            ' ',
                            _this.props.lang[childItem.unit.title_lang_data]
                        )
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-2' },
                    _react3.default.createElement('div', { className: 'price' })
                ),
                _react3.default.createElement('div', { className: 'clearfix' }),
                childItem.type_id === 5 ? childItem.childProducts.map(function (childChildItem) {
                    return _this.renderNested(childChildItem, level + 1);
                }) : null
            );
        };

        _this.renderItems = function () {
            var _this$props = _this.props,
                lang = _this$props.lang,
                orderDetail = _this$props.orderDetail;

            if (orderDetail.type_id === 7) {
                return _react3.default.createElement('div', { className: 'col-xs-12 items-holder no-margin' });
            }
            return _react3.default.createElement(
                'div',
                { className: 'col-xs-12 items-holder no-margin' },
                _react3.default.createElement(
                    'div',
                    { className: 'row no-margin cart-item hidden-xs' },
                    _react3.default.createElement(
                        'div',
                        { className: 'col-sm-1' },
                        lang['store.cart.photo']
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-sm-4' },
                        lang['store.cart.title']
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-sm-3' },
                        lang['store.cart.modifiers']
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-sm-2 text-center' },
                        lang['store.cart.quantity']
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-sm-2 text-center' },
                        lang['store.cart.price']
                    )
                ),
                _this.productsTable()
            );
        };

        _this.totalRow = function (text) {
            var lang = _this.props.lang;

            return _react3.default.createElement(
                'div',
                { className: 'col-xs-12 products_total_price' },
                _react3.default.createElement(
                    'div',
                    { className: 'col-sm-offset-8 col-sm-4 col-xs-12 text-center' },
                    _react3.default.createElement(
                        'div',
                        { className: 'summ_price' },
                        _react3.default.createElement(_components2.MoneyValue, {
                            value: text,
                            icon: _this.props.currency.icon,
                            iconAfterValue: _this.props.currency.icon_after_value,
                            prefix: lang['store.cart.total'] + ': '
                        })
                    )
                )
            );
        };

        return _this;
    }

    (0, _createClass3.default)(PaymentOrderView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                color = _props.color,
                processInput = _props.processInput,
                showProcessInput = _props.showProcessInput,
                orderId = _props.orderId,
                products = _props.products,
                orderDetail = _props.orderDetail,
                lang = _props.lang;

            var sumTotal = orderDetail.sum - orderDetail.discount_sum;
            var date = (0, _moment2.default)(this.props.orderDetail.time_create);

            if (showProcessInput) {
                return _react3.default.createElement(
                    'section',
                    { id: 'payment-page' },
                    _react3.default.createElement(_components2.OrderSteps, { step: '3' }),
                    _react3.default.createElement(
                        'div',
                        { className: 'row no-margin' },
                        _react3.default.createElement(_ProcessInput2.default, { data: processInput, orderId: orderId, products: products, sumTotal: sumTotal })
                    )
                );
            }

            if (this.props.isCompleted || this.props.failError.length > 0) {
                return _react3.default.createElement(
                    'section',
                    { id: 'payment-page' },
                    _react3.default.createElement(_components2.OrderSteps, { step: '3' }),
                    _react3.default.createElement(
                        'div',
                        { className: 'row' },
                        _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12' },
                            _react3.default.createElement(
                                'div',
                                { className: 'payment-order-success' },
                                _react3.default.createElement(
                                    'h2',
                                    { className: 'section-title special_title' },
                                    lang['store.common.order'],
                                    ' \u2116',
                                    orderDetail.order_number
                                ),
                                _react3.default.createElement(
                                    'h5',
                                    null,
                                    '' + date.format('DD.MM.YYYY')
                                )
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12' },
                            _react3.default.createElement(
                                'div',
                                { className: 'small-12 columns' },
                                this.props.isCompleted ? lang['store.payment_order.payment_success'] : this.props.failError
                            )
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'row', id: 'personal-order-detail' },
                        this.renderItems(),
                        this.totalRow('' + parseFloat(sumTotal).toFixed(2))
                    )
                );
            }
            var creditButton = null;
            if (orderDetail.service_in_slug === 'buy_in_credit' && this.props.buyInCreditActive) {
                var discountEpsilon = orderDetail.discount_sum;
                var discountPercent = orderDetail.discount_sum / (orderDetail.sum / 100);
                var itemsStr = '';
                orderDetail.products.forEach(function (item, index) {
                    var modifierOptionName = '';
                    var sale = parseFloat(item.base_price * (discountPercent / 100)).toFixed(2);
                    var price = parseFloat(item.base_price - sale).toFixed(2);
                    discountEpsilon = discountEpsilon - sale * item.quantity;
                    if (item.modifier_option_name !== null) {
                        modifierOptionName = item.modifier_option_name;
                    }
                    if (index === orderDetail.products.length) {
                        price = parseFloat(item.base_price - (sale + discountEpsilon / item.quantity)).toFixed(2);
                    }
                    itemsStr = itemsStr + 'items.' + index + '.name=' + item.name + ' ' + modifierOptionName + '&items.' + index + '.price=' + price + '&items.' + index + '.quantity=' + item.quantity + '&items.' + index + '.vendorCode=' + item.id_yml + '&';
                });
                itemsStr = itemsStr + 'demoFlow=reject&promoCode=' + (this.props.buyInCredit.promo_code === '' ? 'default' : this.props.buyInCredit.promo_code) + '&sum=' + parseFloat(orderDetail.sum - orderDetail.discount_sum).toFixed(2) + '&orderNumber=' + orderDetail.order_number + '&values.contact.mobilePhone=' + orderDetail.client.phone + '&values.contact.email=' + orderDetail.client.email;
                var buyInCreditButtonName = this.props.lang['onlineShop.buyInCredit.button1'] + parseFloat((orderDetail.sum - orderDetail.discount_sum) / 19 || 0).toFixed(2) + ' ' + this.props.lang['onlineShop.buyInCredit.button2'];
                var uiData = 'productType=credit';
                if (this.props.buyInCredit.is_credit == false) {
                    buyInCreditButtonName = this.props.lang['onlineShop.buyInCredit.installments.button1'] + parseFloat((orderDetail.sum - orderDetail.discount_sum) / 19 || 0).toFixed(2) + ' ' + this.props.lang['onlineShop.buyInCredit.button2'];
                    uiData = 'productType=installment';
                }
                creditButton = _react3.default.createElement('tinkoff-create-button', {
                    subtext: buyInCreditButtonName,
                    shopId: this.props.buyInCredit.external_shop_id,
                    showcaseId: this.props.buyInCredit.showcase_id,
                    'ui-data': uiData,
                    'payment-data': itemsStr
                });
            }
            return _react3.default.createElement(
                'section',
                { id: 'payment-page' },
                _react3.default.createElement(_components2.OrderSteps, { step: '3' }),
                _react3.default.createElement(
                    'div',
                    { className: 'row' },
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12' },
                        _react3.default.createElement(
                            'div',
                            { className: 'small-9 columns' },
                            _react3.default.createElement(
                                'h2',
                                { className: 'section-title special_title' },
                                lang['store.common.order'],
                                ' \u2116 ',
                                orderDetail.order_number
                            ),
                            _react3.default.createElement(
                                'h5',
                                null,
                                '' + date.format('DD.MM.YYYY')
                            )
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12' },
                        _react3.default.createElement(
                            'div',
                            { className: 'wait-block' },
                            _react3.default.createElement(
                                'div',
                                { className: 'payment-wait' },
                                lang['store.payment_order.payment_waiting']
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'preload-wait' },
                                _react3.default.createElement('img', { src: '/assets/images/' + color + '.svg', alt: '' })
                            )
                        )
                    )
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'row', id: 'personal-order-detail' },
                    this.renderItems(),
                    this.totalRow('' + parseFloat(sumTotal).toFixed(2)),
                    creditButton
                )
            );
        }
    }]);
    return PaymentOrderView;
}(_react2.Component), _class.propTypes = {
    isCompleted: _react2.PropTypes.bool,
    failError: _react2.PropTypes.string,
    color: _react2.PropTypes.string.isRequired,
    processInput: _react2.PropTypes.object,
    showProcessInput: _react2.PropTypes.bool,
    lang: _react2.PropTypes.object,
    currency: _react2.PropTypes.object
}, _class.defaultProps = {
    showProcessInput: false,
    isCompleted: false,
    failError: ''
}, _temp));

exports.default = PaymentOrderView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Order/default/PaymentOrderView.jsx
// module id = 1823
// module chunks = 0